import React from "react";

export const Logo = ({ onClick, className = "" }) => (
  <a
    href="#acasa"
    onClick={onClick}
    data-testid="logo-link"
    className={`inline-flex items-center group ${className}`}
    aria-label="AN CONTAB AUDIT - Acasă"
  >
    <img
      src="/logo.png"
      alt="AN CONTAB AUDIT - Lighting in Accounting"
      className="h-9 sm:h-10 w-auto object-contain transition-transform duration-300 group-hover:-translate-y-0.5"
    />
  </a>
);
